<template>
	<div class="app-container">

		<div class="h1-buttons">
			<h1>Access Keys</h1>
			<div class="my-2">
				<button class="btn btn-secondary" @click="openCreateDialog()">
					Add Access Key
				</button>
			</div>
		</div>
		
		<table class="table position-relative">
			<thead>
				<tr>
					<th scope="col">Key</th>
					<th scope="col">Created At</th>
					<th scope="col">Updated At</th>
					<th scope="col"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(publicKey, idx) in publicKeys" :key="publicKey.id">
					<td>
						<button class="btn btn-link" @click="edit(publicKey.id)">
							{{ publicKey.id }}
						</button>
					</td>
					<td>{{ publicKey.createdAt | hyperDate }}</td>
					<td>{{ publicKey.updatedAt | hyperDate }}</td>
					<td class="text-right">
						<button class="btn btn-danger" @click="deleteKey(publicKey, idx)">
							<span
								v-if="loading[publicKey.id]"
								class="spinner-border spinner-border-sm mr-2"
								role="status"
								aria-hidden="true"
							></span>
							<i class="fas fa-trash-alt"></i>
						</button>
						<button class="btn btn-secondary" @click="edit(publicKey.id)">
							<i class="fas fa-pen"></i>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<error-dialog ref="ErrorDialog" />
		<public-key-dialog ref="PublicKeyDialog" @saved="load" />
	</div>
</template>

<script>
import PublicKeyService from '../../services/public-key';
import PublicKeyDialog from './PublicKeyDialog';
import ErrorDialog from '../shared/ErrorDialog';

export default {
	name: 'PublicKeyList',
	components: {
		ErrorDialog,
		PublicKeyDialog,
	},
	data() {
		return {
			loading: false,
			publicKeys: [],
			publicKeyLoading: [],
		};
	},
	mounted() {
		this.load();
	},
	methods: {
		async load() {
			this.loading = true;
			return PublicKeyService.instance()
				.list()
				.then(keys => (this.publicKeys = keys))
				.then(keys => (this.publicKeyLoading = Array(keys.length).fill(false)))
				.catch(err => this.$refs.ErrorDialog.show(err))
				.finally(() => (this.loading = false));
		},
		async deleteKey(publicKey, idx) {
			const confirmed = await this.$bvModal.msgBoxConfirm(
				`Are you sure you want to delete access key "${publicKey.id}"?`,
				{
					title: 'Delete Access Key',
				},
			);
			if (!confirmed) {
				return;
			}
			this.publicKeyLoading[idx] = true;
			return PublicKeyService.instance()
				.deleteById(publicKey.id)
				.then(() => this.load())
				.catch(err => this.$refs.ErrorDialog.show(err))
				.finally(() => (this.loading = false));
		},
		edit(id) {
			this.$refs.PublicKeyDialog.show(id);
		},
		openCreateDialog() {
			this.$refs.PublicKeyDialog.show();
		},
	},
};
</script>

<style scoped></style>
